import React from "react";
import "./ViewPaymentSkeleton.css";

const ViewPaymentSkeleton = () => {
  return (
    <section>
      <div className="container-fluid">
        {/* Header */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="skeleton skeleton-btn mb-3"></div>
          </div>
          <div className="col-md-6">
            <div className="skeleton skeleton-title"></div>
          </div>
        </div>

        <hr />

        {/* Status badge */}
        <div className="d-flex justify-content-end mb-4">
          <div className="skeleton skeleton-badge"></div>
        </div>

        <div className="row">
          {/* Payment Details */}
          <div className="col-lg-6 mb-4">
            <div className="card shadow-sm border-0">
              <div className="card-header bg-white">
                <div className="skeleton skeleton-header"></div>
              </div>
              <div className="card-body">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div
                    key={i}
                    className="d-flex justify-content-between mb-3"
                  >
                    <div className="skeleton skeleton-text w-25"></div>
                    <div className="skeleton skeleton-text w-40"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Invoice Details */}
          <div className="col-lg-6 mb-4">
            <div className="card shadow-sm border-0">
              <div className="card-header bg-white">
                <div className="skeleton skeleton-header"></div>
              </div>
              <div className="card-body">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div
                    key={i}
                    className="d-flex justify-content-between mb-3"
                  >
                    <div className="skeleton skeleton-text w-30"></div>
                    <div className="skeleton skeleton-text w-40"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Proof Images */}
          <div className="col-12">
            <div className="card shadow-sm border-0">
              <div className="card-header bg-white">
                <div className="skeleton skeleton-header"></div>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  {[1, 2, 3, 4].map((i) => (
                    <div className="col-md-3 col-sm-6" key={i}>
                      <div className="skeleton skeleton-image"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ViewPaymentSkeleton;
